var React = require("react");
var $ = require('jquery');

import { removeHtmlCode } from '../../../shared/mixin';

var classnames = require('classnames');

var isIE11 = document.documentElement.classList.contains('ie11');
var Ellipsis = isIE11 ? require('./ellipsis_polyfill') : require('patternity/lib/ellipsis');

var ExperienceCardDetails = React.createClass({
  propTypes : {
    maxLines: React.PropTypes.number,
    onChange: React.PropTypes.func
  },

  getDefaultProps: function () {
    return {
      maxLines: 3,
      onChange: function() {}
    };
  },

  render : function(){
    return (
      <div className="challenge-details card__details">
        {this._addChildren()}
      </div>
    );
  },

  _addChildren: function() {
    var that = this;
    return React.Children.map(this.props.children, function(child){
      if( child && child.type.displayName === "ExperienceCardDetails.Headline" ){
        return React.cloneElement(child, {onChange: that.props.onChange});
      }
      return child;
    });
  },

});

ExperienceCardDetails.Headline = React.createClass({
  displayName: 'ExperienceCardDetails.Headline',
  propTypes : {
    headline : React.PropTypes.string,
    onChange : React.PropTypes.func
  },

  getDefaultProps : function(){
    return {
      headline : "",
      onChange : function(){}
    };
  },

  componentDidUpdate: function(nextProps){
    if (this.props.headline !== nextProps.headline) {
      this.props.onChange();
    }
  },

  render : function(){
    return (
      <h3 className="card__headline" ref="headline">
        <Ellipsis text={removeHtmlCode(this.props.headline).substr(0, 200)} maxLines={1} />
      </h3>
    );
  }
});

module.exports = ExperienceCardDetails;



// WEBPACK FOOTER //
// ./src/advocate/challenges/components/experience_card_details.jsx